import { ReactElement, useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import { StateContextPropertyType, useStateContext } from "../reducers";
import { Menu } from "./Menu";

function AppRoutes() {
    const {authState}: StateContextPropertyType = useStateContext();

    const routes = useMemo(() => {
        const parsedMenus: ReactElement[] = [];
        Menu.filter((m) => (m.id === "Ubah Password" || m.id === "Logout" || (authState?.daftar_menu?.filter(dm => m.children.filter(c => dm.can_view && c.code === dm.kode_menu)?.length).length)) && !m.isOnlyLink)
            .forEach((m, idx) => {
                if (!m.children?.filter(c => c.path).length)
                {
                    parsedMenus.push(<Route key={`route_${idx}`} path={m.path} element={m.component} />);

                    if (m.formPath && m.formComponent)
                        parsedMenus.push(<Route key={`route_${idx}_form`} path={m.formPath} element={m.formComponent} />);
                    
                    return;
                }

                m.children.filter(c => c.path).forEach((c, c_idx) => {
                    parsedMenus.push(<Route key={`route_${idx}_${c_idx}`} path={`${m.path}${c.path}`} element={c.component} />);

                    if (c.formPath && c.formComponent)
                        parsedMenus.push(<Route key={`route_${idx}_${c_idx}`} path={`${m.path}${c.formPath}`} element={c.formComponent} />);
                });
            })

        return parsedMenus;
    }, [authState?.daftar_menu]);

    return (
        <Routes>
            <Route path="/login" element={authState?.token && authState.token !== "" ? <Dashboard /> : <Navigate to="/login" replace />} />
            <Route path="/" element={authState?.token && authState.token !== "" ? <Dashboard /> : <Navigate to="/login" replace />} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            {
                routes
            }
        </Routes>
    )
};

export default AppRoutes;

export function OtherRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};
